'use client';
import { CartProvider } from '@/app/(webapp)/_contexts/cart-provider';
import { AuthProvider } from '@/app/_shared/context/auth';
import { UserDataProvider } from '@/app/_shared/context/auth/user-data-provider';
import { MswProvider } from '@/app/_shared/context/msw-provider';
import { apolloClient, setApolloLocale } from '@/app/_shared/lib/apollo-client';
import { routing } from '@/i18n/routing';
import { ApolloProvider } from '@apollo/client';
import type { Locale } from 'next-intl';
import { NextIntlClientProvider, hasLocale } from 'next-intl';
import { notFound } from 'next/navigation';
import type React from 'react';
import { useEffect } from 'react';

export default function Providers({
    children,
    locale,
    messages,
}: {
    children: React.ReactNode;
    locale: Locale;
    messages: unknown;
}) {
    if (!hasLocale(routing.locales, locale)) {
        notFound();
    }

    useEffect(() => {
        setApolloLocale(locale);
    }, [locale]);

    return (
        <MswProvider>
            <ApolloProvider client={apolloClient}>
                <NextIntlClientProvider locale={locale} messages={messages as Record<string, unknown>}>
                    <AuthProvider>
                        <UserDataProvider>
                            <CartProvider>{children}</CartProvider>
                        </UserDataProvider>
                    </AuthProvider>
                </NextIntlClientProvider>
            </ApolloProvider>
        </MswProvider>
    );
}
